import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import Login from './pages/auth/Login'
import Signup from './pages/auth/Signup'
import ForgotPassword from './pages/auth/ForgotPassword'
import Dashboard from './pages/Dashboard'
import Overview from './pages/Dashboard/Overview'
import EditVCard from './pages/Dashboard/EditVCard'
import QRCode from './pages/Dashboard/QRCode'
import Analytics from './pages/Dashboard/Analytics'
import Billing from './pages/Dashboard/Billing'
import Themes from './pages/Dashboard/Themes'
import Settings from './pages/Dashboard/Settings'
import VCardPage from './pages/VCard'
import ProtectedRoute from './components/ProtectedRoute'
import { TermsConditions, PrivacyPolicy, RefundPolicy, Contact, ShippingPolicy } from './pages/legal'

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/v/:username" element={<VCardPage />} />
      
      {/* Legal Pages */}
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/shipping" element={<ShippingPolicy />} />
      
      {/* Protected Dashboard Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      }>
        <Route index element={<Overview />} />
        <Route path="edit" element={<EditVCard />} />
        <Route path="qr" element={<QRCode />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="billing" element={<Billing />} />
        <Route path="themes" element={<Themes />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  )
}

export default App
